/**
 * Dismiss LOCAL de tareas en la campanita (por usuario, localStorage).
 *
 * Las tareas vencidas NO son background_jobs: vienen de core.v_my_due_tasks.
 * "Quitar" una de la campanita NO borra la tarea ni toca la DB — solo la oculta
 * en este browser/usuario. Espeja el patrón `seen` de los jobs (loadSeen/saveSeen).
 */
const KEY_PREFIX = 'dendev-bell-dismissed-tasks-v1';

export function loadDismissedTaskIds(userId: string): Set<string> {
  try {
    const raw = localStorage.getItem(`${KEY_PREFIX}-${userId}`);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as string[]);
  } catch {
    return new Set();
  }
}

export function saveDismissedTaskIds(userId: string, ids: Set<string>) {
  try {
    // Tope de 200 ids para no crecer infinito (igual que `seen`).
    localStorage.setItem(`${KEY_PREFIX}-${userId}`, JSON.stringify([...ids].slice(-200)));
  } catch {
    /* noop */
  }
}
